const NON_REMOVAL_REASON_I18N_KEYS = {
  bulky: "Too bulky",
  covered: "Covered by a new layer of waste",
  soiled: "Soiled object",
  multi_material: "Multi-material object",
  incorrect_ai_identification: "Incorrect AI identification",
  treated_wood: "Treated wood",
  other: "Other",
};

export const getNonRemovalReasonList = (t) => [
  { value: "bulky", label: t(NON_REMOVAL_REASON_I18N_KEYS.bulky) },
  {
    value: "covered",
    label: t(NON_REMOVAL_REASON_I18N_KEYS.covered),
  },
  { value: "soiled", label: t(NON_REMOVAL_REASON_I18N_KEYS.soiled) },
  {
    value: "multi_material",
    label: t(NON_REMOVAL_REASON_I18N_KEYS.multi_material),
  },
  {
    value: "incorrect_ai_identification",
    label: t(NON_REMOVAL_REASON_I18N_KEYS.incorrect_ai_identification),
  },
  {
    value: "treated_wood",
    label: t(NON_REMOVAL_REASON_I18N_KEYS.treated_wood),
  },
  { value: "other", label: t(NON_REMOVAL_REASON_I18N_KEYS.other) },
];

export const formatNonRemovalReason = (comment, t) => {
  const reasonValue = comment?.reason?.value;
  if (reasonValue === "other") {
    const specificReason = comment?.specificReason?.trim();
    return specificReason || t(NON_REMOVAL_REASON_I18N_KEYS.other);
  }

  const i18nKey = NON_REMOVAL_REASON_I18N_KEYS[reasonValue];
  if (i18nKey) {
    return t(i18nKey);
  }

  return comment?.reason?.label || t("Unknown");
};
